import React from 'react'
import style from "./subjects.module.css"

const Subjects = () => {
  return (
    <div className={style.learning_subjects}>
       <h3 className='section-tittle'>Subjects Catalogue</h3>
       <div className="container">
          <div className={style.core_subjects}>
        
              <h3>Core Subjects</h3>
              <h4 className={style.similarH4}>Mathematics and Numeracy</h4>
              <p id='cambridge_p'>Avana homeschooling offers a high quality mathematics education which provides a solid foundation for our learners to understand the world, the ability to reason mathematically, an appreciation of the beauty of mathematics, and a sense of enjoyment and curiosity about Mathematics.</p>
              <h4 className={style.similarH4}>Our mathematics policy</h4>
              <p id='cambridge_p'>Majority of our pupils move through the mathematics programme of study at broadly the same pace. Decisions on progressing are always based on the security of pupils' understanding and their readiness to progress to the next stage. Learners who grasp concepts rapidly are always challenged and offered rich and sophisticated problems before any acceleration through new content. Learners who are not sufficiently fluent with earlier materials always consolidate their understanding, including additional practice and revision exercises before moving on.</p>
              <h4 className={style.similarH4}>English</h4>
              <p id='cambridge_p'>Language and literacy; Avana East Africa develops spoken language, reading, writing, and vocabulary as integral aspects. We believe fluency in English is an essential foundation for success in all subjects.</p>
              <h4 className={style.similarH4}>Swahili language school</h4>
              <p id='cambridge_p'>Jambo! Jambo!</p>
              <p id='cambridge_p'>Avana homeschooling offers a wide range of Swahili language courses you can take online, anywhere, anytime. Learning Swahili helps you improve your communication skills in a professional setting for career development, students, family, business, recreation, or new opportunities.</p>
              <p id='cambridge_p'>Our Swahili curriculum covers the 4 main acquisition skills: Listening, Speaking, Reading, and Writing.</p>
              <p id='cambridge_p'>Are you a student learning Swahili or struggling in some Swahili topics: Cambridge, IB, Edexcel, IGCSE, KCSE, KCPE? Enroll for your classes! What are you waiting for? Do you want to connect with friends, business, colleagues, or family members abroad? Do you have plans to travel or live overseas and enjoy the rich wildlife heritage in East Africa? Deepen your connection with the Swahili culture while making the most beautiful experiences on your safari around East Africa.</p>
              <p id='cambridge_p'>Swahili is a language that is spoken both nationally and internationally. We offer a structured approach for people and also learners who are beginners to non-native Swahili users from primer course to advanced course.</p>
       
          </div>
          <div>
          <div className={style.subjects_catalogue}>
  <div>
    <h4 className={style.similarH4}>CORE SUBJECTS (MANDATORY)</h4>
    <p id='cambridge_p'>
      <ul>
        <li>English</li>
        <li>Science</li>
        <li>Math</li>
        <li>Handwriting and Work arrangement</li>
      </ul>
    </p>
  </div>
  <div>
    <h4 className={style.similarH4}>SCHOOL OF HUMANITIES</h4>
    <p id='cambridge_p'>
      <ul>
        <li>History</li>
        <li>Geography</li>
        <li>Global perspectives</li>
        <li>Citizenship</li>
        <li>Law</li>
        <li>Archaeology</li>
        <li>Anthropology</li>
        <li>Geology</li>
      </ul>
    </p>
  </div>
  <div>
    <h4 className={style.similarH4}>SCIENCE SCHOOL</h4>
    <p id='cambridge_p'>
      <ul>
        <li>Science</li>
        <li>Agriculture</li>
        <li>Environment</li>
        <li>Physics</li>
        <li>Chemistry</li>
        <li>Biology</li>
        <li>Home science</li>
      </ul>
    </p>
  </div>
  <div>
    <h4 className={style.similarH4}>LANGUAGE SCHOOL</h4>
    <p id='cambridge_p'>
      <ul>
        <li>Swahili</li>
        <li>French</li>
        <li>Arabic</li>
        <li>German</li>
        <li>Luhya</li>
        <li>Dholuo</li>
        <li>Kikuyu</li>
        <li>Marakwet</li>
        <li>Luganda</li>
        <li>Kamba</li>
        <li>Samburu</li>
        <li>Gusii</li>
      </ul>
    </p>
  </div>
  <div>
    <h4 className={style.similarH4}>SOCIAL SCIENCES</h4>
    <p id='cambridge_p'>
      <ul>
        <li>Sociology</li>
        <li>Psychology</li>
      </ul>
    </p>
  </div>
  <div>
    <h4 className={style.similarH4}>RELIGIOUS EDUCATION</h4>
    <p id='cambridge_p'>
      <ul>
        <li>Islamic Religious Education (IRE)</li>
        <li>Christian Religious Education</li>
      </ul>
    </p>
  </div>
  <div>
    <h4 className={style.similarH4}>SCHOOL OF BUSINESS</h4>
    <p id='cambridge_p'>
      <ul>
        <li>Business</li>
        <li>Accounting and Finance</li>
      </ul>
    </p>
  </div>
  <div>
    <h4 className={style.similarH4}>PROGRAMMING AND COMPUTER SCIENCE</h4>
    <p id='cambridge_p'>
      <ul>
        <li>Basic</li>
        <li>HTML</li>
        <li>CSS</li>
        <li>C++</li>
        <li>Python</li>
      </ul>
    </p>
  </div>
</div>







                      </div>
                      </div>
                      </div>
                      )
}

export default Subjects
